import React from 'react';
import { ServiceTemplate } from '../ServiceTemplate';
import { copyrightRegistrationData } from '../../servicesData';

export const CopyrightRegistration = ({ onOpenPopup }) => {
  return (
    <ServiceTemplate
      service={copyrightRegistrationData}
      onOpenPopup={onOpenPopup}
      showPricing={false}
    />
  );
};